import React from 'react';
import VisitorPage from '../../VisitorPage/VisitorPage';

const Visitor = () => {
  return(
    <div>
        <VisitorPage />
    </div>
  );
};

export default Visitor;
